module.exports = __webpack_public_path__ + "assets/img/img180.e2b5858c.png";